import { API } from "../api";
import { APISpec } from "../spec";
const ChemAPI = process.env.REACT_APP_API_CHEM;

export const ChemSpec = APISpec(ChemAPI, "GET", "/chem/v2/openapi");
export const ChemUpload = API(ChemAPI, "POST", "/chem/upload");
export const ChemHistory = API(ChemAPI, "GET", "/chem/history");
export const ChemDownloadDiagram = API(ChemAPI, "POST", "/chem/download");
export const ChemDownloadSnippet = API(ChemAPI, "POST", "/chem/download/snippet");
